/**
 * O selo "de onde vêm os dados" da lista de Clientes do Legado.
 *
 * "Sincronizado com a planilha" só quando existe planilha: a do Google Drive
 * configurada no servidor ou um arquivo lido neste aparelho. Sem nenhuma, a
 * tela diz isso — antes ela afirmava sincronia com uma planilha que não
 * existia (marcenaria sem o Gerenciador via "Sincronizado" e carteira vazia).
 */
export function seloDaSincronizacao({ erroServidor, loading, servidorConfigurado, meta, statusPlanilha } = {}) {
  if (erroServidor) return { rotulo: "Planilha sem sincronizar", desligado: true };
  if (loading) return { rotulo: "Lendo a planilha…", desligado: false };
  const temPlanilha = Boolean(servidorConfigurado || meta?.arquivoLido || statusPlanilha?.arquivoEncontrado);
  if (!temPlanilha) return { rotulo: "Nenhuma planilha configurada", desligado: true };
  return { rotulo: "Sincronizado com a planilha", desligado: false };
}
